import React from 'react';
import ImgHTML from '../ImgHTML';

const IndustriesSingleItem = ({ item }) => {
  return (
    <div className="col-md-6">
      <div className="single-item">
        <div className="icon">
          <ImgHTML src={item.icon} alt="enterprise icon" />
        </div>
        <div className="content">
          <div className="tt">{item.title}</div>
          <div className="dd">
            <ul>
              {item.list.map(listItem => (
                <li key={listItem}>{listItem}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesSingleItem;
